/**
 * The scene twin of the shoulder recenter's declaration: read/write
 * `extras.poqpoq.shoulderRecenter` on the Upperarm node of the SELECTED
 * skeleton (three carries userData ↔ extras both ways, so it rides export).
 *
 * Depends on: kernel (marker schema), convert-rig (skeleton selection).
 * Depended on by: run-document (the cap-height door).
 */
import type { Object3D } from 'three';
import {
  parseShoulderRecenterMarker,
  withShoulderRecenterMarker,
  type ShoulderRecenterMarker,
} from '@harryhausen/kernel';
import { boneOfSelectedSkeleton } from './convert-rig.js';

type Selection = { label: string; selectSkeleton?: string };

export function readSceneShoulderRecenter(root: Object3D, bone: string, options: Selection): ShoulderRecenterMarker | null {
  const node = boneOfSelectedSkeleton(root, bone, options);
  if (!node) throw new Error(`No shoulder node ${bone} in ${options.label}`);
  return parseShoulderRecenterMarker(node.userData, `${bone} in ${options.label}`);
}

export function writeSceneShoulderRecenter(
  root: Object3D,
  bone: string,
  marker: ShoulderRecenterMarker,
  options: Selection,
): void {
  const node = boneOfSelectedSkeleton(root, bone, options);
  if (!node) throw new Error(`No shoulder node ${bone} in ${options.label}`);
  node.userData = withShoulderRecenterMarker(node.userData, marker);
}
